import React, { Component } from 'react';
import * as Sentry from '@sentry/browser';

// Sentry.init({
//  dsn: "https://73340ff28b7f47f6b38728a950506d40@sentry.goodwix.com/3"
// });
// should have been called before using it here
// ideally before even rendering your react app

export default class CatchErrors extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    Sentry.withScope((scope) => {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;

    if (error) {
      // render fallback UI
      // eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events
      return <a onClick={() => Sentry.showReportDialog()}>Report feedback</a>;
    }

    // when there's not an error, render children untouched
    return children;
  }
}



// WEBPACK FOOTER //
// ./CatchErrors.jsx